import { BrowserRouter, Switch, Route, Link } from "react-router-dom";
import SSO from "./pages/SSO/index";
import Login from "./pages/SSO/Login";
import ForgotPassword from "./pages/SSO/ForgotPassword";
import SSOError from "./pages/SSO/SSOError";
import NotFound from "./common/NotFound";
import LearnMore from "./pages/LearnMore";
import ClearSession from "./common/ClearSession";
import SignUp from "./pages/SSO/SignUp";
const CompleteSignUp = () => { return <h3 className="text-center mt-4">Complete sign up process! <br /> <small>Coming soon!!</small> <br /> <small>You can only access cloud after completing this step.</small> <br /><br /> <small><Link to="/clear-session">Click here to log out</Link></small> </h3> }

const Router = (props: any) => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/sso/:app" children={<SSO />} />
                <Route path="/login" component={Login} />
                <Route path="/sign-up/complete" component={CompleteSignUp} />
                <Route path="/sign-up" component={SignUp} />
                <Route path="/forgot-password" component={ForgotPassword} />
                <Route path="/learn-more" component={LearnMore} />
                <Route path="/sso-error" children={<SSOError />} />
                <Route path="/clear-session" children={<ClearSession />} />
                <Route component={NotFound} />
            </Switch>
        </BrowserRouter>
    );
}

export default Router;